// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    jQuery(document).ready(function () {
        var $root = document.querySelectorAll('.horizontalList');
        $root = $($root);
        //Grid Placeholder 1 Column Horizontal List
        // $.components.registerComponent('.horizontalList', function ($root) {
        var horizontalList = {
                dom: {
                    children: $root.children()
                },
                set: {
                    width: $root.width(),
                    numChildren: $root.children().length,
                    windowWidth: jQuery(window).width(),
                    padding: 5,
                    maxWidth: 768
                },
                fn: {
                    getWidth: function () {
                        return ($set.width - $set.padding * $set.numChildren) / $set.numChildren;
                    }
                }
            },
            $dom = horizontalList.dom,
            $set = horizontalList.set,
            $fn = horizontalList.fn;

        if ($set.width > $set.maxWidth) {
            var newWidth = $fn.getWidth();
            $dom.children.each(function () {
                jQuery(this).width(newWidth);
            });
        } else {

            $dom.children.each(function () {
                jQuery(this).css("width", "100%");
            });
        }
        //});

    });

})(window, document, jQuery);